/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import { Injectable } from '@angular/core';
import {NbRoleProvider} from '@nebular/security';
import {Observable, of} from 'rxjs';
import {AuthService} from './auth.service';

@Injectable()
export class RoleProviderService implements NbRoleProvider {

  constructor(private readonly authService: AuthService) {
  }


  getRole(): Observable<string[]> {
    return this.authService.isAuthenticated() ? of(this.authService.getRoles()) : of(['anonymous']);
  }

}
